import _ from 'lodash';
import {
  COUPON_EMAIL_SEND_SIGNUP_MODAL,
  COUPON_TEXT_SEND_SIGNUP_MODAL,
  HOMEPAGE_MID_SIGNUP_MODAL,
  LOYALTY_SIGNUP_MODAL,
  NAVBAR_SIGNUP_MODAL,
  OUTLINE_CSS_CLASS,
  SIGNUP_PAGE_SIGNUP_MODAL,
  PHARMACY_PRICE_LIST_MODAL,
  SOFT_COUPON_MODAL,
  HAMBURGER_MENU_MODAL,
  MENU_CHECK_LANG,
  GLP_SIGNUP_MODAL,
  EXCLUDE_SPANISH_LINK
} from '../constants/defaults';
import route from '../constants/route.json';
import { authActions } from '../reducers/authSlice';
import { getUserPoints } from '../actions/auth';
import { fetchSavedDrugs, getSavedCoupons } from '../actions/userDrug';
import { Errors } from '../constants/errors';

const handleNavMenuItemClick = text => {
  _.triggerGTMVirtualPageViewEvent({
    event: 'navMenuItemClick',
    clickText: text
  });
};

_.mixin({
  /**
   * Delay the execution of an asynchronous code with execution.
   * @param {number} ms - The amount of time (in milliseconds) execution needs to wait.
   */
  delayExecution: ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  },

  /**
   * Convert the query string to json object.
   * @param {string} queryString - The URL params from URL.
   */
  queryStringToJSON: queryString => {
    if (queryString.indexOf('?') > -1) {
      queryString = queryString.split('?').splice(1).join('?');
    }
    const pairs = queryString.split('&');
    let result = {};
    pairs.forEach(pair => {
      pair = pair.split('=');
      pair[1] = pair.splice(1).join('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return result;
  },

  /**
   * Function to check if loggedin or logged out view.
   *  return true for loggedout user and false for logged in user.
   */

  isPublicView: () => {
    return _.isEmpty(_.getCookie('sessionId'));
  },

  // convert "MM/DD/YYYY" to "YYYY/MM/DD" Format

  parseDate: birthDate => {
    const splitDate = birthDate.split('/');
    return `${splitDate[2]}/${splitDate[0]}/${splitDate[1]}`;
  },

  // convert "YYYY/MM/DD" to MM/DD/YYYY Format

  convertDate: birthDate => {
    const splitDate = birthDate.split('/');
    return `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`;
  },

  numToStringForKeys: (object = {}, keys = []) => {
    let convertedParams = {};
    keys.forEach(key => {
      if (object?.[key])
        convertedParams[key] =
          typeof object[key] == 'number' ? object[key].toString() : object[key];
    });
    return convertedParams;
  },

  isSignupFormValid: formData => {
    const { Email, birthDate, FName, LName, emailKickboxErr } = formData;
    return (
      _.validateEmail(Email) &&
      !_.calculateAgeNew(birthDate) &&
      _.validateName(FName) &&
      _.validateName(LName) &&
      !emailKickboxErr
    );
  },

  isValidPassword: formData => {
    const {
      capitalLetter,
      eightChar,
      lowerCaseLetter,
      oneNumber,
      passwordMatch
    } = formData;
    return (
      capitalLetter &&
      eightChar &&
      lowerCaseLetter &&
      oneNumber &&
      passwordMatch
    );
  },

  referenceCardValidity: formData => {
    const { FName, JobTitle, PharmacyAddress, Zip, City, State, Email } =
      formData;
    return (
      _.validateName(FName) &&
      _.validateEmail(Email) &&
      !_.isEmpty(JobTitle) &&
      !_.isEmpty(PharmacyAddress) &&
      !_.isEmpty(Zip) &&
      !_.isEmpty(City) &&
      !_.isEmpty(State)
    );
  },

  withLocale: (lng, path) => {
    if (_.isEqual(lng, 'es') && !path.includes('/es/')) {
      if (_.isEqual(path, '/')) {
        return '/es';
      } else {
        let paths = path.trim().split('/');
        //checks if any of the substrings from EXCLUDE_SPANISH_LINK exist in the path
        if (
          paths.length > 3 &&
          !EXCLUDE_SPANISH_LINK.some(keyword => path.includes(keyword))
        ) {
          let newPath = route.spanishMapping.find(
            item => item.en === '/' + paths[1]
          );
          return newPath && newPath.es
            ? path.includes('browse-prescriptions') && paths[3].length > 2
              ? `/es${newPath.es}/${paths[2]}/${paths[2]}-otro`
              : `/es${newPath.es}/${paths[2]}/${paths[3]}`
            : path;
        }
        if (paths.length > 2 && !path.includes('/content')) {
          let newPath = route.spanishMapping.find(
            item => item.en === '/' + paths[1]
          );
          return newPath && newPath.es ? `/es${newPath.es}/${paths[2]}` : '/es';
        } else {
          let newPath = route.spanishMapping.find(item => item.en === path);
          return newPath && newPath.es ? `/es${newPath.es}` : '/es';
        }
      }
    } else {
      if (
        !(
          path.trim().split('/').length > 1 &&
          path.trim().split('/')[1] === 'es'
        )
      ) {
        return path;
      } else {
        if (_.isEqual(path, '/es')) return '/';
        let paths = path.trim().split('/');
        const basePath = route.spanishMapping.find(
          item => item.es === '/' + paths[2]
        );
        if (paths.length > 4)
          return basePath && basePath.en
            ? path.includes('buscar-medicamentos') && paths[4].length > 2
              ? `${basePath.en}/${paths[3]}/${paths[3]}-other`
              : `${basePath.en}/${paths[3]}/${paths[4]}`
            : path;
        if (paths.length > 3)
          return basePath && basePath.en
            ? path.includes('recursos')
              ? `${basePath.en}`
              : `${basePath.en}/${paths[3]}`
            : path;
        if (paths.length > 2)
          return basePath && basePath.en ? basePath.en : path;
        let newPath = route.spanishMapping.find(
          item => item.es === path.replace('/es', '')
        );
        return newPath && newPath.en ? `${newPath.en}` : path;
      }
    }
  },

  isInViewport: elem => {
    if (!_.isEmpty(elem)) {
      var bounding = elem.getBoundingClientRect();
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  },

  formatPhoneNumber: str => {
    //Filter only numbers from the input
    let cleaned = ('' + str).replace(/\D/g, '');

    //Check if the input is of correct
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      //Remove the matched extension code
      //Change this to format for any country code.
      let intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  },

  getIsMobileDevice: () => {
    let check = false;
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    )
      check = true;
    return check;
  },

  /*return date in format "M/D/YYYY" or "D Mon YYYY"
   * safari and IE not supported date format with -
   * e.g 02-02-2020 will replace - with /
   *  if date format is iso 8601 we are not replacing it with -
   * */
  getFormattedDate: (date, format) => {
    !_.isIsoDate(date) && (date = date.replace(/-/g, '/'));
    const currentDate = new Date(date);
    const currentMonth = (currentDate.getMonth() + 1).toString();
    const currentDay = currentDate.getDate().toString();
    let month = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    if (format === 'D Mon YYYY') {
      return `${currentDay} ${
        month[currentDate.getMonth()]
      } ${currentDate.getFullYear()}`;
    } else if (format === 'Mon D YYYY') {
      return `${month[currentDate.getMonth()]} ${currentDay},
       ${currentDate.getFullYear()}`;
    } else if (format === 'M/D/YYYY') {
      return currentMonth + '/' + currentDay + '/' + currentDate.getFullYear();
    } else if (format === 'DD/MM/YYYY') {
      return (
        (currentDay.length > 1 ? currentDay : '0' + currentDay) +
        '/' +
        (currentMonth.length > 1 ? currentMonth : '0' + currentMonth) +
        '/' +
        currentDate.getFullYear()
      );
    } else {
      return (
        (currentMonth.length > 1 ? currentMonth : '0' + currentMonth) +
        '/' +
        (currentDay.length > 1 ? currentDay : '0' + currentDay) +
        '/' +
        currentDate.getFullYear()
      );
    }
  },

  isIsoDate: str => {
    if (
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/.test(
        str
      )
    )
      return true;
    return false;
  },

  getNewFormattedDate: (date, format) => {
    if (!date) return '';

    // Convert string to a valid Date object
    let currentDate;

    // If it's already a Date object
    if (date instanceof Date) {
      currentDate = date;
    } else {
      // Try to normalize date string for Safari/mobile
      // Safari doesn't like 'YYYY-MM-DD', prefers 'YYYY/MM/DD'
      const normalizedDate = date.replace(/-/g, '/').replace(/T.+/, ''); // remove time if present

      currentDate = new Date(normalizedDate);
    }

    // If still invalid, fallback to current date
    if (isNaN(currentDate)) currentDate = new Date();

    const day = currentDate.getDate().toString().padStart(2, '0');
    const monthNum = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear();
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];

    switch (format) {
      case 'D Mon YYYY':
        return `${parseInt(day)} ${monthNames[currentDate.getMonth()]} ${year}`;
      case 'Mon D YYYY':
        return `${monthNames[currentDate.getMonth()]} ${parseInt(
          day
        )}, ${year}`;
      case 'M/D/YYYY':
        return `${monthNum}/${parseInt(day)}/${year}`;
      case 'DD/MM/YYYY':
        return `${day}/${monthNum}/${year}`;
      default:
        return `${monthNum}/${day}/${year}`;
    }
  },

  setFocusWithoutReload: (ele, nextSelector) => {
    setTimeout(() => {
      window.dispatchEvent(
        new KeyboardEvent('keydown', {
          key: 'Tab'
        })
      );
      let element = document.querySelector(ele);
      let focusElement = element.querySelector(nextSelector);
      while (_.isEmpty(focusElement) && !_.isUndefined(element)) {
        element = element.nextElementSibling;
        focusElement = element.querySelector(nextSelector);
      }
      focusElement && focusElement.focus();
    }, 800);
  },

  setIsKeyboardUser: (isKeyboard, event) => {
    const element = event.target;
    const eleType = element.type;
    if (
      element.tagName === 'INPUT' &&
      (eleType === 'password' ||
        eleType === 'text' ||
        eleType === 'email' ||
        eleType === 'search' ||
        eleType === 'number' ||
        eleType === 'date')
    ) {
      const classList = element.classList;
      const isContain = classList.contains(OUTLINE_CSS_CLASS);
      isKeyboard
        ? isContain || classList.add(OUTLINE_CSS_CLASS)
        : isContain && classList.remove(OUTLINE_CSS_CLASS);
    }
  },

  setUserData: (loginResponse, dispatch, savedLinkClicked) => {
    let pageFrom = '';
    if (
      (typeof window !== 'undefined' &&
        window.location.pathname.match(/^\/prescription\/[A-Za-z0-9-_]*$/)) ||
      window.location.pathname.match(/^\/es\/medicamento\/[A-Za-z0-9-_]*$/)
    ) {
      pageFrom = '/prescription'; //this is fro redux store only, not impact on spanish
      dispatch(
        authActions.pageAction({
          isDrugPriceLoad: false
        })
      );
    }
    dispatch(
      authActions.login({
        user: {},
        pageFrom: pageFrom
      })
    );
    if (!savedLinkClicked) {
      dispatch(getSavedCoupons());
      dispatch(fetchSavedDrugs());
    }
  },

  setUserPoints: (loginResponse, dispatch) => {
    dispatch(getUserPoints(loginResponse.data.prospectId));
  },

  getSignUpPath: modal => {
    let path = '';
    switch (modal) {
      case LOYALTY_SIGNUP_MODAL:
        path = 'coupon modal';
        break;
      case NAVBAR_SIGNUP_MODAL:
        path = 'nav bar signup CTA';
        break;
      case HOMEPAGE_MID_SIGNUP_MODAL:
        path = 'homepage mid-page signup CTA';
        break;
      case SIGNUP_PAGE_SIGNUP_MODAL:
        path = '/signup page';
        break;
      case COUPON_TEXT_SEND_SIGNUP_MODAL:
        path = 'coupon text sent confirmation signup CTA';
        break;
      case COUPON_EMAIL_SEND_SIGNUP_MODAL:
        path = 'coupon email sent confirmation signup CTA';
        break;
      case PHARMACY_PRICE_LIST_MODAL:
        path = 'pharmacy price list';
        break;
      case SOFT_COUPON_MODAL:
        path = 'soft coupon gate';
        break;
      case HAMBURGER_MENU_MODAL:
        path = 'nav menu';
        break;
      case GLP_SIGNUP_MODAL:
        path = '/glp1';
        break;
      default:
        path = '';
    }
    return {
      signUpPath: { loyaltySignupPath: path },
      signUpPathWithInvite:
        typeof window !== 'undefined' &&
        window.location.pathname.split('/').includes('invite')
          ? {
              loyaltySignupPath:
                window.location.origin + window.location.pathname
            }
          : { loyaltySignupPath: path }
    };
  },

  getPharmacyALTName: pharmacyName => {
    return _.endsWith(_.lowerCase(pharmacyName), 'pharmacy')
      ? pharmacyName
      : `${pharmacyName} Pharmacy`;
  },

  getURLRefCode: props => {
    const refCode = props.match.params.refCode;
    if (_.isEmpty(props.userName) && !_.isEmpty(refCode)) {
      return refCode;
    }
    return '';
  },

  getReferralLink: referralLink => {
    return referralLink
      ? `${window.location.origin}/invite/${referralLink}`
      : typeof window !== 'undefined' &&
        window.location.pathname.split('/').includes('invite')
      ? window.location.origin + window.location.pathname
      : '';
  },
  createIDFromPharmacyName: pharmacyName => {
    return pharmacyName.split(' ').join('-');
  },
  validatePassword: value => {
    if (_.isEmpty(value.trim())) {
      return Errors.Required;
    } else if (
      !(
        value.length >= 8 &&
        /[a-z]/.test(value) &&
        /[0-9]/.test(value) &&
        /[A-Z]/.test(value) &&
        /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value)
      ) ||
      /\s/.test(value)
    ) {
      return Errors.InvalidPassword;
    } else {
      return '';
    }
  },
  createIDFromHeader: header => {
    header = header?.replace(/[^a-zA-Z ]/g, '');
    header = header?.replace(/ /g, '-');
    return header?.toLowerCase();
  },
  getMemberMenuList: (t, lang) => {
    return [
      {
        name: 'Coupons',
        icon: '/content/images/icons/singlecare-menu-logo.svg',
        url: _.withLocale(lang, '/save-drugs'),
        check: [MENU_CHECK_LANG],
        others: {
          onClick: () => handleNavMenuItemClick('Coupons')
        }
      },
      {
        name: 'Drugs',
        icon: '/content/images/icons/drugs-menu-logo.svg',
        url: _.withLocale(lang, '/save-drugs?drug=true'),
        check: [MENU_CHECK_LANG],
        others: {
          onClick: () => handleNavMenuItemClick('Drugs')
        }
      },
      {
        name: t('Profile'),
        icon: '/content/images/icons/user-menu-logo.svg',
        url: _.withLocale(lang, '/account-setting'),
        others: {
          onClick: () => handleNavMenuItemClick('Profile')
        }
      },
      {
        name: t('Account history'),
        icon: '/content/images/icons/menu-stars-icon.svg',
        url: _.withLocale(lang, '/member-center'),
        others: {
          onClick: () => handleNavMenuItemClick('Account history')
        }
      },
      {
        name: t('Bonus savings balance'),
        url: _.withLocale(lang, '/member-center'),
        others: {
          onClick: () => handleNavMenuItemClick('Bonus savings balance')
        },
        spanishLink: true,
        showUserPoints: true
      },
      {
        name: t('Communication preferences'),
        url: _.withLocale(lang, '/communications-preferences'),
        others: {
          onClick: () => handleNavMenuItemClick('Communication preferences')
        },
        spanishLink: _.isEqual(lang, 'en'),
        showUserPoints: false
      }
    ];
  },
  getAccordianMenu: (t, lang, isUserLogin) => {
    let isEs = _.isEqual(lang, 'es');
    return [
      {
        heading: t('SingleCare'),
        links: [
          {
            name: t('About us'),
            url: _.withLocale(lang, '/about-us'),
            others: {
              id: 'slmFootAboutUs',
              onClick: () => handleNavMenuItemClick('About us')
            }
          },
          ...(isEs
            ? []
            : [
                {
                  name: t('Press'),
                  url: _.withLocale(lang, '/press'),
                  others: {
                    onClick: () => handleNavMenuItemClick('Press')
                  }
                }
              ]),
          {
            name: t('Nonprofits'),
            url: _.withLocale(lang, '/partners'),
            others: {
              onClick: () => handleNavMenuItemClick('Nonprofit partners')
            }
          },
          ...(isEs
            ? []
            : [
                {
                  name: 'Brokers & affiliates',
                  url: 'https://partners.singlecare.com',
                  others: {
                    target: '_blank',
                    rel: 'noreferrer',
                    onClick: () =>
                      handleNavMenuItemClick('Broker/Affiliate partners')
                  }
                }
              ]),
          ...(isEs
            ? [
                {
                  name: t('Recursos'),
                  url: '/es/recursos',
                  others: {
                    id: 'slmFootCareers',
                    rel: 'noopener noreferrer',
                    onClick: () => handleNavMenuItemClick('Recursos')
                  }
                }
              ]
            : []),

          {
            name: t('Careers'),
            url: 'https://singlecare.applicantstack.com/x/openings',
            others: {
              id: 'slmFootCareers',
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: () => handleNavMenuItemClick('Careers')
            }
          },

          ...(isEs
            ? []
            : [
                {
                  name: 'Health blog',
                  url: _.withLocale(lang, '/blog/'),
                  check: [MENU_CHECK_LANG],
                  others: {
                    onClick: () => handleNavMenuItemClick('Health blog'),
                    target: '_blank'
                  }
                }
              ])
        ]
      },
      {
        heading: t('Using SingleCare'),
        links: [
          {
            name: t('How it works'),
            url: _.withLocale(lang, '/how-it-works'),
            others: {
              onClick: () => handleNavMenuItemClick('How it works')
            }
          },
          {
            name: t('Medicare'),
            url: _.withLocale(lang, '/medicare'),
            others: {
              id: 'slmFootMedicare',
              rel: 'noopener noreferrer',
              onClick: () => handleNavMenuItemClick('Medicare')
            }
          },
          ...(isEs
            ? []
            : [
                {
                  name: 'Mobile apps',
                  url: _.withLocale(lang, '/app'),
                  check: [MENU_CHECK_LANG],
                  others: {
                    id: 'mobileApps',
                    onClick: () => handleNavMenuItemClick('Mobile apps'),
                    target: '_blank'
                  }
                }
              ]),
          {
            name: t('Drug discount card'),
            url: _.withLocale(lang, '/prescription-discount-card'),
            others: {
              onClick: () => handleNavMenuItemClick('Discount cards')
            }
          },
          {
            name: t('Help / FAQ'),
            url: _.withLocale(lang, '/help'),
            others: {
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: () => handleNavMenuItemClick('Help')
            }
          },
          {
            name: t('Customer reviews'),
            url: 'https://www.trustpilot.com/review/www.singlecare.com',
            icon: '/content/images/header/external-link-icon.svg',
            others: {
              target: '_blank',
              rel: 'noreferrer',
              onClick: () => handleNavMenuItemClick('Customer reviews')
            }
          }
        ]
      },

      {
        heading: t('Browse drugs by'),
        links: [
          ...(isEs
            ? []
            : [
                {
                  name: 'Condition symptoms',
                  url: _.withLocale(lang, '/conditions-symptoms'),
                  others: {
                    id: 'slmFootSymptoms',
                    rel: 'noopener noreferrer',
                    onClick: () => handleNavMenuItemClick('Condition symptoms')
                  }
                },
                {
                  name: 'Condition causes',
                  url: _.withLocale(lang, '/conditions-causes'),
                  others: {
                    id: 'slmFootCauses',
                    rel: 'noopener noreferrer',
                    onClick: () => handleNavMenuItemClick('Condition causes')
                  }
                },
                {
                  name: 'Condition treatments',
                  url: _.withLocale(lang, '/conditions-treatments'),
                  others: {
                    id: 'slmFootConditions',
                    rel: 'noopener noreferrer',
                    onClick: () =>
                      handleNavMenuItemClick('Condition treatments')
                  }
                },
                {
                  name: 'Drug classes',
                  url: _.withLocale(lang, '/drug-classes'),
                  check: [MENU_CHECK_LANG],
                  others: {
                    id: 'slmFootDrugClasses',
                    onClick: () => handleNavMenuItemClick('Drug Classes')
                  }
                },
                {
                  name: 'Drug resource center',
                  url: _.withLocale(lang, '/resources'),
                  check: [MENU_CHECK_LANG],
                  others: {
                    id: 'slmFootDrugResources',
                    onClick: () =>
                      handleNavMenuItemClick('Drug resource center')
                  }
                }
              ]),
          {
            name: t('Popular drugs link'),
            url: _.withLocale(lang, '/browse-prescriptions#td'),
            others: {
              id: 'slmFootPharmacy',
              onClick: () => handleNavMenuItemClick('Browse Prescriptions')
            }
          },
          {
            name: t('Drug names A-Z'),
            url: _.withLocale(lang, '/browse-prescriptions#az'),
            others: {
              id: 'slmFootPharmacy',
              onClick: () => handleNavMenuItemClick('Drug names A-Z')
            }
          },
          ...(isUserLogin
            ? [
                {
                  name: t('SingleCare drug list'),
                  url: '/2Q24_SingleCare_Program_Formulary.pdf',
                  others: {
                    target: '_blank',
                    onClick: () =>
                      handleNavMenuItemClick('SingleCare drug list')
                  }
                }
              ]
            : [])
        ]
      },
      {
        heading: t('Need help'),
        links: [
          {
            data: t('Available 24/7, except major holidays')
          },
          {
            subHeading: t('Customers'),
            name: '844-234-3057',
            url: 'tel:844-234-3057'
          },
          {
            subHeading: t('Providers'),
            name: '800-960-6918',
            url: 'tel:800-960-6918'
          },
          {
            subHeading: t('General'),
            name: 'support@singlecare.com',
            url: 'mailto:support@singlecare.com'
          }
        ]
      }
    ];
  }
});
